const RUN_RE = /^(\d{4})(\d{2})(\d{2})(\d{2})$/
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export function isValidRun(run) {
  return typeof run === "string" && RUN_RE.test(run)
}

// Runs are YYYYMMDDHH, so string order is time order. A rollback is not "new".
export function isNewerRun(next, known) {
  return isValidRun(next) && isValidRun(known) && next > known
}

export function formatRunLabel(run) {
  const match = isValidRun(run) ? run.match(RUN_RE) : null
  if (!match) return run ?? ""
  const [, year, month, day, hour] = match
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}, ${hour} UTC`
}

export function newRunMessage(run) {
  return (
    `New weather forecast available (run ${formatRunLabel(run)}). ` +
    "Routes calculated with an older forecast are marked as outdated."
  )
}
